import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { toSelect } from 'utils/genericFunctions';
import { Types, consultaCarroceria } from './types';

export const INITIAL_STATE: consultaCarroceria = {
	status: 0,
	data: [],
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): consultaCarroceria {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTA_CARROCERIA_REQUEST: {
				break;
			}

			case Types.CONSULTA_CARROCERIA_SUCCESS: {
				draft.status = action.payload.status;
				const select = toSelect(
					action.payload.data.carrocerias,
					'descricao',
					'longId',
				);
				draft.data = select;
				break;
			}

			case Types.CONSULTA_CARROCERIA_FAILURE: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			default:
		}
		return draft;
	});
}
